<template>
  <div class="BranchRoleManagement">
      分公司角色管理
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>